import { middlewareAPI } from './api';
import { authService } from "../auth/services/auth";

const GET_HEADER = {
    method: 'GET',
    credentials: 'include',
    headers: {
        'Content-Type': 'application/json'
    }
}
const POST_HEADER = {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    credentials: 'include'
}

export const middlewareService  = {
    serviceGet,
    servicePost,
    cartServicePost,
    getApiData,
    postApiData,
    postApiService,
    getApiService,
}

function handleErrors(response) {
    if ( response && response.status === 401) {
        return authService.logout()
    }

    if(response && response.status === 400) {
        return response.json();
    }

    if (!response.ok) {
        throw Error(response.status);
    }
    
    return response.json();
}

function handleBlobErrors(response) {
    if ( response && response.status === 401) {
        return authService.logout()
    }

    if (!response.ok) {
        throw Error({status: false, message: "something went wrong, please try again"})
    }
    
    return response.blob();
}

function serviceGet(apiName, requestOptions) {
    requestOptions.method = 'GET';
    return middlewareAPI.apiCall(apiName, requestOptions);
}

function servicePost(apiName, requestOptions) {
    requestOptions.method = 'POST';
    return middlewareAPI.apiCall(apiName, requestOptions);
}

function cartServicePost(apiName, requestOptions) {
    requestOptions.method = 'POST';
    return middlewareAPI.cartApiCall(apiName, requestOptions);
}

// Fixed header api
function getApiData(url) {
    let _url = process.env.REACT_APP_API_URL + url;
    return fetch(_url, GET_HEADER)
        .then(handleErrors)
        .catch(error => ({ success: false, error: error }));
}

//Fixed header api
function postApiData(url, payload) {
    let _url = process.env.REACT_APP_API_URL + url;

   /* if (window.$isAmazon ) {
        payload["source"] = process.env.REACT_APP_AMAZON_FESTIVAL_SOURCE;
    } */

    let options = { ...POST_HEADER };
    options.body = JSON.stringify(payload);
    return fetch(_url, options)
        .then(handleErrors)
        .catch(error => ({ success: false, error: error }));
}

export function postDownloadApi(url, formData) {
    let options = {
        ...POST_HEADER,
        ...{ "use-pkey": false }
    };
    options.body = JSON.stringify(formData);
    let _url = process.env.REACT_APP_REPORTS_API_URL + url;
    return fetch(_url, options)
        .then(handleBlobErrors)
        .catch(error => ({ success: false, error: error }));
}

function postApiService (url, payload) {
    const options = {...POST_HEADER};
    options.body = JSON.stringify(payload);
    return fetch(process.env.REACT_APP_API_URL + url, options).then(
        resp => resp.json()).then(response => response)
}

function getApiService(url) {
    return fetch(process.env.REACT_APP_API_URL + url, GET_HEADER).then(
        resp => resp.json()).then(response => response)
}